<template lang="html">
  <v-my-layout>
    <div
      slot="body"
      class=""
    >
      {{ $t("general.resetPassword.placeholder") }}
    </div>
  </v-my-layout>
</template>

<script>

import VMyLayout from '@/layouts/Default.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'ResetPasswordIndex',

  /**
   * The components that the page can use.
   */
  components: {
    VMyLayout,
  },
};
</script>

<style lang="scss" scoped>
</style>
